import React from 'react';
import Header from './Header';
import Footer from './Footer';
import Breadcrumb from './Breadcrumb';
import Sidebar from './Sidebar';
import { Container } from 'react-bootstrap';
import { ToastContainer } from 'react-toastify';
import './Layout.css';

const Layout = ({ children, routes, fluid }) => {
  return (
    <>
    <div className="layout-wrapper">
      <Sidebar />
      <div className="layout-content">
        <Header />
        <Container className="layout-main" fluid={fluid}>
          <Breadcrumb routes={routes} />
          {children}
        </Container>
        <Footer />
      </div>
    </div>
    <ToastContainer />
    </>
  );
};

export default Layout;
